import React, { ReactNode, useState } from 'react';
import './ContentBlock.scss';

import penIcon from 'assets/images/icons/pen.svg';
import { Loader } from 'components/Loader/Loader';

export type ContentBlockProps = {
    title?: string;
    postIt?: boolean;
    isEditable?: boolean;
    isLoading?: boolean;
    editIcon?: ReactNode;
    onEditClick?: () => void;
    editState?: boolean;
} & React.ComponentPropsWithoutRef<'div'>;

export const ContentBlock: React.FC<ContentBlockProps> = ({
    title,
    children,
    className,
    postIt,
    onEditClick = () => {},
    isEditable = false,
    editIcon = <img src={penIcon} alt="" />,
    editState = false,
    isLoading = false
}) => {

    return (
        <div className={`content-block ${postIt ? 'post-it' : ''} ${className}`}>
            {isLoading && <div className="content-block-loading-container"><Loader /></div>}
            {isEditable && !editState && (
                <span
                    className="edit-icon"
                    onClick={() => {
                        onEditClick();
                    }}
                >
                    {editIcon}
                </span>
            )}
            {title && <h2 className="title">{title}</h2>}
            <div className="content">{children}</div>
        </div>
    );
};
